import WidgetConnections from './WidgetConnections';

export default WidgetConnections;
